import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-showcase-workshop',
  templateUrl: './showcase-workshop.component.html',
  styleUrls: ['./showcase-workshop.component.scss']
})
export class ShowcaseWorkshopComponent implements OnInit {
  deleteSpaceSuccess: any;
  show: boolean;
  text: string;
  toggle = true;
  value: any;
  value1: any;
  value2: any;
  value3: any;
  value4: any;
  value5: any;

  constructor() {
    this.show = true;
    this.text = 'close';
  }
  ngOnInit() {

  }

  toggleMenu() {
    this.toggle = !this.toggle;
  }
}



